import { PaginatedItin } from './../shared/models/paginated-itin.model';
import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { Itin } from '../core/itinerari/itinerari.model';
import { ItinActionService } from '../core/itinerari/itinerari.action';

@Injectable()
export class ItinListResolver implements Resolve<Itin[]> {
  @select(['itin', 'list'])
  itinList$: Observable<Itin[]>;

  constructor(private service: ApiService,
              private itinAction: ItinActionService) {}

  resolve() {
    return this.service.getItin(
      0,
      null,
      null,
      null,
      null,
      true
    ).pipe(
      first(),
      tap((paginatedItin: PaginatedItin) => {
        this.itinAction.paginatedItinList(paginatedItin);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di itinerari');
        return of(err);
      })
    );
  }
}
